import React from 'react';
import CourseLandingScreen from '../../../components/courseLandingScreen';
import CCMRSSyle from '../style';
import bannerImage from '../../../images/CCMRS/banner.png';
import CourseDescriptionV2Image from '../../../images/CCMRS/CCMRCourseDescriptionV201.png';
import CourseDescription from '../../../components/courseDescription/index';
import WarningBlock from '../../../components/warningBlock';
import CourseDescriptionV2 from '../../../components/courseDescriptionV2';
import NextBackNav from '../../../components/nextBackNav';
import Banner from '../../../components/banner';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = CCMRSSyle();
	return (
		<div style={style.outerStyle()}>
			<CourseLandingScreen mt={true} title='C.C.M.R.’S / CONSTANT CARDIO MUSCLE ROUNDS' />
			<Banner
				addonStyle={style.bannerStyle()}
				bgImage={bannerImage}
				title={`There is always room for improvement`}
				alignment='left'
				mt={true}
			/>
			<CourseDescription
				addonStyle={style.courseDescriptionStyle()}
				title='C.C.M.R’S / CONSTANT CARDIO MUSCLE ROUNDS'
				texts={[
					'CONSTANT/CARDIO MUSCLE ROUNDS also known as C.C.M.R’s, is a mixture of exercises emphasizing one muscle group.',
					' The Individual will perform these exercises with extreme focus and constant movement with no breaks until the round is over. C.C.M.R’S are exercises that focus on what I like to call “The Big Four.” Chest, Back, Legs, and Your Cardiovascular System. The prominent role of this program is create a strong foundation for your body.',
				]}
			/>
			<WarningBlock
				mt={true}
				texts={[
					'“The C.C.M.R’s Program requires a Gym with a Crossfit setup that has all the compound exercise equipment included and also provides space for functional movement to be able to perform the program exercises properly.”',
				]}
			/>
			<CourseDescriptionV2
				texts={[
					'(Alpha) are Compound Heavy Duty exercises targeting the initial muscle groups while also engaging the whole body as well. This causes Hypertrophy and more Calories Burnt.',
					'(Beta)-(Beta-PLYO/Cardio) are bodyweight exercises or exercises done with light to mild weight. It also includes Cardiovascular Exercises. This helps break more muscle fibers and give the muscle a more efficient burn, boosting endurance for your cardiovascular system.',
				]}
				addonStyle={style.CourseDescriptionV201ContainerStyle()}
				bgImage={CourseDescriptionV2Image}
				title={'NO LIMITS'}
			/>

			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
